import RoutingService from 'services/RoutingService';

export const useProjectName = () => {
  let project = RoutingService.getProjectFromUrl();

  return project
}